import { render, staticRenderFns } from "./contentLectureOther.vue?vue&type=template&id=330a361c&"
import script from "./contentLectureOther.vue?vue&type=script&lang=js&"
export * from "./contentLectureOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports